import { instance } from "./apiClient";

export const customStocksApi = {
  getCustomStocks: () =>
    instance.get("/api/custom_stocks").then((res) => res.data),

  createCustomStock: (payload) =>
    instance.post("/api/custom_stocks", payload).then((res) => res.data),

  updateCustomStock: (id, payload) =>
    instance.put(`/api/custom_stocks/${id}`, payload).then((res) => res.data),

  deleteCustomStock: (id) =>
    instance.delete(`/api/custom_stocks/${id}`).then((res) => res.data),
};
